import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { first, map, tap } from 'rxjs/operators';
import {
  MdmInstalledApplicationsStoreActions,
  MdmInstalledApplicationsStoreState,
} from '../mdm-installed-applications';
import { DevicesRouterStoreSelectors, RouterStoreStates } from '../router';

@Injectable()
export class MdmInstalledApplicationsResolver {
  constructor(
    private readonly routerStore: Store<RouterStoreStates.RouterState>,
    private readonly MdmInstalledApplicationsStore: Store<MdmInstalledApplicationsStoreState.InstalledApplicationsState>
  ) {}

  resolve(): Observable<boolean> {
    return this.routerStore.select(DevicesRouterStoreSelectors.selectUdid).pipe(
      tap((udid) => {
        this.MdmInstalledApplicationsStore.dispatch(
          MdmInstalledApplicationsStoreActions.MdmInstalledApplicationsResolverActions.installedApplicationsRequested({
            udid,
          })
        );
      }),
      map(() => true),
      first()
    );
  }
}
